import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute, Content } from "../_metronic/layout";
import AddCompany from "./modules/Company/AddCompany";
import Currencies from "./modules/Currencies";
import APKScreenList from "./modules/Master/APKScreenList";
// import Levels from "./modules/Master/Levels";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
// import { DashboardPage } from "./pages/DashboardPage";
// import { create } from './tournaments/create';
// import CommonForm from "./modules/Tournaments/CommonForm";
import AddTeam from "./modules/Tournaments/addteam";

import TournamentContest from "./modules/Tournaments/TournamentContest";
import TournamentView from "./modules/Tournaments/TournamentView";
import TournamentReports from "./modules/Tournaments/TournamentReports";
import GamerjiTournamentView from "./modules/Tournaments/GamerjiTournamentView";
import GamerjiTournamentPointSummary from "./modules/Tournaments/GamerjiTournamentPointSummary";
import GamerjiTournamentRankSummary from "./modules/Tournaments/GamerjiTournamentRankSummary";
import EditCmsOm from "./modules/CompanyCms/om/edithowtojoin";
import EditCmsD11 from "./modules/CompanyCms/d11/HowToJoin/edithowtojoin";
import EditCmsME from "./modules/CompanyCms/me/HowToJoin/edithowtojoin";
import EditCmsBS from "./modules/CompanyCms/bs/HowToJoin/edithowtojoin";
import EditCmsJP from "./modules/CompanyCms/jagran/HowToJoin/edithowtojoin";
import EditCmsCC from "./modules/CompanyCms/cellcard/HowToJoin/edithowtojoin";
import EditCmsGJ from "./modules/CompanyCms/Gamerji/HowToJoin/edithowtojoin";
import EditCmsGP from "./modules/CompanyCms/goPlay/HowToJoin/edithowtojoin";
import EditCmsAM from "./modules/CompanyCms/ampere/HowToJoin/edithowtojoin";
import EditCmsOP from "./modules/CompanyCms/OP/HowToJoin/edithowtojoin";
import EditCmsOM from "./modules/CompanyCms/onMob/HowToJoin/edithowtojoin";
import EditCmsGLO from "./modules/CompanyCms/GLO/HowToJoin/edithowtojoin";
import EditCmsTLB from "./modules/CompanyCms/TLB/HowToJoin/edithowtojoin";
import EditCmsJZ from "./modules/CompanyCms/JZ/HowToJoin/edithowtojoin.js";
import EditCmsETL from "./modules/CompanyCms/ETL/HowToJoin/edithowtojoin.js";
import EditCmsEP from "./modules/CompanyCms/EP/HowToJoin/edithowtojoin.js";
import EditCmsSCP from "./modules/CompanyCms/SCP/HowToJoin/edithowtojoin.js";
import EditCmsVC from "./modules/CompanyCms/VC/HowToJoin/edithowtojoin.js";
import TournamentTeams from "./modules/Tournaments/TournamentTeams";
import RankSummary from "./modules/Tournaments/RankSummary";
import TournamentPointSummaryView from "./modules/Tournaments/TournamentPointSummaryView";
import helperFunc from "../_metronic/_helpers/helperFunc";
import { userCoinConsumerReportSlice } from "./modules/Reports/UsersCoinConsumerReport/_redux/staffUsersSlice";
import { AllTimeLeaderBoard } from "./modules/LeaderBoard/AllTimeLeaderboard";
import { MonthlyLeaderBoard } from "./modules/LeaderBoard/MonthlyLeaderboard";
import { TodaysLeaderboard } from "./modules/LeaderBoard/TodaysLeaderBoard";
import { WeeklysLeaderboard } from "./modules/LeaderBoard/WeeklyLeaderBoard";
import GamerjiTournament from "./modules/Tournaments/Gamerjicommonform";
import CreateUserId from "./modules/Users/StaffUser/CreateUserId";
import H5categories from "./modules/H5categories";
import H5Games from "./modules/H5Games";
import CouponCategories from "./modules/CouponCategories";
import LeadgerSummaryReport from "./modules/Reports/LeadgerSummaryReport/ListComponent.js";
import Adslogs from "./modules/DownloadAdscompanylist/Adslogs/Adslogs";
import AdscompanyView from "./modules/DownloadAdscompanylist/addads/addads";
import Companydetailpage from "./modules/DownloadAdscompanylist/Companydetailpage/Companydetailpage";
import AllnewReports from "./modules/AllNewReport/index.js"
// import NewAside from "../_metronic/layout/components/NewLayout.js";
// import  Aside  from "../_metronic/layout/components/NewLayout.js";
//coin store
const CoinStores = lazy(() => import("./modules/CoinStores/index"));
// coin store
const GoogleMaterialPage = lazy(() => import("./modules/GoogleMaterialExamples/GoogleMaterialPage"));
const ReactBootstrapPage = lazy(() => import("./modules/ReactBootstrapExamples/ReactBootstrapPage"));
const ECommercePage = lazy(() => import("./modules/ECommerce/pages/eCommercePage"));
const UserProfilepage = lazy(() => import("./modules/UserProfile/UserProfilePage"));

//roles and permission -> module
const Modulepage = lazy(() => import("./modules/RoleAndPermission/ModulePage"));
const Role = lazy(() => import("./modules/RoleAndPermission/Roles"));
//roles and permission -> module

const Countries = lazy(() => import("./modules/Countries/index"));
const CountriesFrontend = lazy(() => import("./modules/Countries-Frontend/index"));
const States = lazy(() => import("./modules/State/index.js"));
const Cities = lazy(() => import("./modules/City/index.js"));
const Appuserpage = lazy(() => import("./modules/Users/App-users"));
const BasicButtons = lazy(() => import("../../src/app/muicomponents/index.js"));
const DeleteRequest = lazy(() => import("./modules/Users/DeleteRequest"));
const Webuserpage = lazy(() => import("./modules/Users/Web-users"));
const Alluserpage = lazy(() => import("./modules/Users/All-users"));
const StaffUserpage = lazy(() => import("./modules/Users/StaffUser"));
const Affiliatepage = lazy(() => import("./modules/AffiliateProgram"));
const Safaricompage = lazy(() => import("./modules/SafaricomReport/index.js"));
const Talabatcompage = lazy(() => import("./modules/TalabatReport/index.js"));
const Bisbcompage = lazy(() => import("./modules/BisbReport/index.js"));
const Indggcompage = lazy(() => import("./modules/IndggReport/index.js"));
const Ooredoocompage = lazy(() => import("./modules/OoredooReport/index.js"));
const Glocompage = lazy(() => import("./modules/GloReport/index.js"));
const StaffUserForm = lazy(() => import("./modules/Users/StaffUser/CommonForm"));
const AffiliateForm = lazy(() => import("./modules/AffiliateProgram/CommonForm.js"));
const StaffUserFormnew = lazy(() => import("./modules/Users/StaffUser/CommonFormnew.js"));
const PointCategories = lazy(() => import("./modules/PointCategories/index"));
const HackerList = lazy(() => import("./modules/Users/Hackers"));
const LiveStreaming = lazy(() => import("./modules/LiveStreaming/index"));
// const StaffUserEdit = lazy(() =>
//   import("./modules/Users/StaffUser/CommonForm")
// );
const Analytics = lazy(() => import("./modules/Analytics/analytics"));

// Reports Starts
const UsersReport = lazy(() => import("./modules/Reports/UsersReport"));
// const LeadgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport"));
const LoginLogsReport = lazy(() => import("./modules/Reports/Loginlogsreport"));
const UsersPlayedGamesReport = lazy(() => import("./modules/Reports/UsersPlayedGamesReport"));
const UsersCoinConsumerReport = lazy(() => import("./modules/Reports/UsersCoinConsumerReport"));
const MarketingReport = lazy(() => import("./modules/Reports/MarketingReport"));
const RetentionReport = lazy(() => import("./modules/Reports/RetentionReport"));
const TournamentReport = lazy(() => import("./modules/Reports/TournamentReport"));
const RetentionReportView = lazy(() => import("./modules/Reports/RetentionReport/RetentionReportView"));
const BuyCoinsReport = lazy(() => import("./modules/Reports/BuyCoinsReport"));
const BuyBundlesReport = lazy(() => import("./modules/Reports/BuyBundlesReport"));
const CashfreeTransactionsReport = lazy(() => import("./modules/Reports/CashfreeTransactionsReport"));
const UsersLedgerReport = lazy(() => import("./modules/Reports/UsersLedgerReport"));
const LedgerSummaryReport = lazy(() => import("./modules/Reports/UsersLedgerReport/LedgerSummaryReport"));

// Leadger Summary Report Companywise diffrent 
const GamerjiLedgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport"));
const gGamerjiLedgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport/GJ/gjindex.js"));
const gGamerjiLedgerSummaryReportpromotionalreport = lazy(() => import("./modules/Reports/LeadgerSummaryReport/GJ/gjpromotionalreport.js"));
const gVILedgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport/VI/viindex.js"));
const gD11LedgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport/D11/d11index.js"));

const gMELedgerSummaryReport = lazy(() => import("./modules/Reports/LeadgerSummaryReport/ME/meindex.js"));


// const CmsCompanyList = lazy(() => import("./modules/CompanyCms"));
const BusinessDailyReport = lazy(() => import("./modules/Reports/BusinessDailyReport"));
const RequestLogReport = lazy(() => import("./modules/Reports/requestLogReport"));
const AppFlyerReport = lazy(() => import("./modules/Reports/appFlyerReports"));
const AddEvents = lazy(() => import("./modules/Reports/appFlyerReports/AppEvents"));
const AppEventsList = lazy(() => import("./modules/Reports/appEvents"));
const CreateRequestLogReport = lazy(() =>
  import("./modules/Reports/AddRequestLog/index.js")
);
const RequestLogCalendarReport = lazy(() =>
  import("./modules/Reports/ReportCalendar/index.js")
);
const AllTimeRetentionReport = lazy(() => import("./modules/Reports/AllTimeRetentionReport"));
// import  from "./modules/Tournaments";
// const ReportsDownloads = lazy(() =>
//   import("./modules/Reports/ReportsDownloads")
// );
const ContestsReportt = lazy(() => import("./modules/Reports/ContestsReport"));

const UserLeaderboardReport = lazy(() => import("./modules/Reports/UserLeaderboardReport"));
const GstReport = lazy(() => import("./modules/Reports/GstReport"));
const Rewardss = lazy(() => import("./modules/Reward/index"));
const DownloadReport = lazy(() => import("./modules/Reports/ReportsDownloads"));
const LogDownloadReport = lazy(() => import("./modules/Reports/LogsDownloads"));

const UserGameLeaderboardReport = lazy(() => import("./modules/Reports/UserGameLeaderboardReport"));
const Retention = lazy(() => import("./modules/Reports/Retention"));
const WithdrawalsRequestReport = lazy(() => import("./modules/Reports/WithdrawalsRequestReport"));
const WalletSummaryReport = lazy(() => import("./modules/Reports/WalletSummaryReport"));
const CrmReport = lazy(() => import("./modules/Reports/CrmReport"));
// Reports Ends

// Withdrawals Request Starts
const WithdrawalsRequest = lazy(() => import("./modules/WithdrawalsRequest"));
// Withdrawals Request Ends
const Languages = lazy(() => import("./modules/Languages/index"));
//scrim
const ScrimsReport = lazy(() => import("./modules/Reports/ScrimsReport"));
const ScrimTransactionReport = lazy(() => import("./modules/Reports/ScrimTransactionReport"));
const ScrimView = lazy(() => import("./modules/Scrims/ScrimView"));
const AddGameScrimSetting = lazy(() => import("./modules/Game/GameScrimSetting"));
const ScrimsList = lazy(() => import("./modules/Scrims"));
const DownloadAdscompanylist = lazy(() => import("./modules/DownloadAdscompanylist"));

const HostReport = lazy(() => import("./modules/Reports/ScrimReport"));
const GamewiseReport = lazy(() => import("./modules/Reports/GamewiseReport"));
const CompanyReport = lazy(() => import("./modules/Reports/CompanyReport"));
const AdsReport = lazy(() => import("./modules/Reports/AdsReport"));
const AdsPosition = lazy(() => import("./modules/Reports/AdsPosition"));

//scrim
const UsersPurched = lazy(() => import("./modules/Reports/UsersPurched"));
const JoinPaidGame = lazy(() => import("./modules/Reports/JoinPaidGame"));
const UsersRedeemrewards = lazy(() => import("./modules/Reports/UsersRedeemrewards"));

//ads company
const AdscompanyList = lazy(() => import("./modules/DownloadAdscompanylist"));
const Adsaddcompany = lazy(() => import("./modules/DownloadAdscompanylist/Addcompany/Addcompany.js"));

//end ads company

// Subscription Pack
const SubscriptionList = lazy(() => import("./modules/Subscription/SubscriptionList"));
const SubscriptionUserList = lazy(() => import("./modules/Subscription/SubscriptionUserList"));
const Addsubscriptionpack = lazy(() => import("./modules/Subscription/addsubscription.js"));
const Subscriptionsetting = lazy(() => import("./modules/Subscription/Subscriptionsetting"));

// Contests Starts
const ContestList = lazy(() => import("./modules/NewContest/ContestList"));
const CasualContestList = lazy(() => import("./modules/CasualContest/ContestList/index.js"));
const OreedooContestList = lazy(() => import("./modules/NewContest/OreedooContestList"))
const ContestView = lazy(() => import("./modules/Contests/ContestList/ContestView"));
const CasualContestView = lazy(() => import("./modules/CasualContest/ContestList/AllCasualContestList/CasualContestView.js"));
const PartnerContestView = lazy(() => import("./modules/Contests/ContestList/PartnerContestView"));
const OoredooContestView = lazy(() => import("./modules/NewContest/OreedooContestList/ContestView.js"));
const TournamentContestView = lazy(() => import("./modules/Contests/TournamentContestList/TournamentContestView"));
const TournamentContestAssign = lazy(() => import("./modules/Tournaments/ContestAssign/index"));
const NewTournamentContestAssign = lazy(() => import("./modules/Tournaments/AddContestAssign/index"));
const TournamentContestReAssign = lazy(() => import("./modules/Tournaments/ContestReAssign/index"));
const InstallableContestView = lazy(() => import("./modules/Contests/ContestList/InstallableContestView"));
const ContestCategories = lazy(() => import("./modules/Contests/ContestCategories"));
const AddContestCategories = lazy(() => import("./modules/Contests/ContestCategories/AddContestCategories"));
const ContestsReport = lazy(() => import("./modules/Contests/ContestsReport"));
const NewContestsReport = lazy(() => import("./modules/Contests/NewContestsReport"));
const ViContestsReport = lazy(() => import("./modules/ViContestReport"));
const R11ContestsReport = lazy(() => import("./modules/R11ContestsReport"));
const TournamentCommonForm = lazy(() => import("./modules/Tournaments"));
const TournamentSelect = lazy(() => import("./modules/Tournaments"));
const ListComponent = lazy(() => import("./modules/Tournaments"));
const ContestUserList = lazy(() => import("./modules/Contests/ContestUserList"));
const ContestTransactions = lazy(() => import("./modules/Contests/ContestTransactions"));

const GeneralSettings = lazy(() => import("./modules/GeneralSettings/index"));
const ContestAssign = lazy(() => import("./modules/Contests/ContestAssign"));
const AuditContest = lazy(() => import("./modules/Contests/AuditContest"));
const ContestAssignShortLink = lazy(() => import("./modules/Contests/ContestAssignShortLink"));
// Contests Ends
const ExtraListComponent = lazy(() => import("./modules/Users/Hackers"));
// New Contests Module
const NewContestTypeModule = lazy(() => import("./modules/NewContest/ContestTypes"));
const AddContestTypeModule = lazy(() => import("./modules/NewContest/AddContestTypes"));
const NewContestShortLink = lazy(() => import("./modules/NewContest/ContestShortLink"));
const NewContestEventList = lazy(() => import("./modules/NewContest/ContestEventList"));
const AddContestShortLink = lazy(() => import("./modules/NewContest/AddContestShortLink"));
const NewContestUserList = lazy(() => import("./modules/NewContest/ContestUserList"));
const NewContestUserFrom = lazy(() => import("./modules/NewContest/ContestUserList/AddContestUser"));
const NewContestAssignList = lazy(() => import("./modules/NewContest/ContestAssign"));
const AddContestAssign = lazy(() => import("./modules/NewContest/AddContestAssign"));
const NewContestReAssignList = lazy(() => import("./modules/NewContest/ContestReAssign"));
const NewAuditContestsList = lazy(() => import("./modules/NewContest/AuditContests"));
const NewAddContest = lazy(() => import("./modules/NewContest/AddContest"));
const CasualNewAddContest = lazy(() => import("./modules/CasualContest/AddContest/index.js"));
const NewContestView = lazy(() => import("./modules/NewContest/ContestList/ContestView"));
const NewContestBoard = lazy(() => import("./modules/NewContest/ContestBoard"));
// New Contests Module End

// User Profile New Starts
const UserProfileMainPage = lazy(() => import("./modules/UserProfileNew/UserProfileMainPage"));
const RewardsBasicProfile = lazy(() => import("./modules/RewardTransactions/RewardsView"));

// User Profile New Ends
const Blogs = lazy(() => import("./modules/Blogs/index"));
const Aside = lazy(() => import("../_metronic/layout/components/aside/NewAside.js"));
// Roles Starts
const NewRole = lazy(() => import("./modules/Roles/NewRole"));
// Roles Ends

// Audit Starts
const AuditReasons = lazy(() => import("./modules/Audits/AuditReasons"));
// Audit Ends

// Rewards Starts
const RewardsTransaction = lazy(() => import("./modules/Rewards/RewardsTransaction"));
const RewardsCategories = lazy(() => import("./modules/Rewards/RewardsCategories"));
const RewardsProductsList = lazy(() => import("./modules/Rewards/RewardsProductsList"));
const RewardsLiveProducts = lazy(() => import("./modules/Rewards/RewardsLiveProducts"));
// Rewards Ends

// Youtube Starts
const ChannelRequests = lazy(() => import("./modules/Youtubes/ChannelRequests"));
// Youtube Ends

// HTML5Games Starts
const HTML5GamesCategories = lazy(() => import("./modules/HTML5Games/HTML5GamesCategories"));
const HTML5GamesList = lazy(() => import("./modules/HTML5Games/HTML5GamesList"));
const HTML5GamesJoiningList = lazy(() => import("./modules/HTML5Games/HTML5GamesJoiningList"));
const HTML5GamesWiseJoiningList = lazy(() => import("./modules/HTML5Games/HTML5GameWiseJoiningList"));
const Setting = lazy(() => import("./modules/H5Games/Setting"));
const Categories = lazy(() => import("./modules/CouponCategories"));

const Coupons = lazy(() => import("./modules/Coupons"));

//company forms
const staffUsersList = lazy(() => import("./modules/StaffUser/"));
//company forms
const Company = lazy(() => import("./modules/Company/AddCompany/index"));

const AddCompanyForm = lazy(() => import("./modules/Company/AddCompanyForm/index"));
//Company forms Ends
//Coin Package
const CoinPackages = lazy(() => import("./modules/CoinStores/CoinPackages/index"));
const AddCoinForm = lazy(() => import("./modules/CoinStores/AddCoinForm/index"));
// HTML5Games Ends

// Game
const GameList = lazy(() => import("./modules/Game/GameList"));
const AddGame = lazy(() => import("./modules/Game/AddGame"));
// const AddGame = lazy(() => import("./modules/Games/CasualGame/casualGameList.js"));
const CasualGameListGame = lazy(() => import("./modules/Games/CasualGame/casualGameList.js"));
const CasualGameAddGame = lazy(() => import("./modules/Games/CasualGame/casualGameAdd.js"));
const CasualGameViewGame = lazy(() => import("./modules/Games/CasualGame/CasualGameView.js"));
const CasualGameAssignGame = lazy(() => import("./modules/Games/CasualGame/CasualGameAssign.js"));
const CasualGameTemplateList = lazy(() => import("./modules/CasualGame/Template/list.js"));
const CasualGameContestList = lazy(() => import("./modules/CasualGame/Contest/list.js"));
const CasualGameContestDetail = lazy(() => import("./modules/CasualGame/Contest/detail.js"));
const AddGameSetting = lazy(() => import("./modules/Game/GameSetting"));

//External Platform
const ExternalPlatformList = lazy(() => import("./modules/ExternalPlatform/GameList/index.js"));
const AddExternalPlatformList = lazy(() => import("./modules/ExternalPlatform/AddGame/index.js"));

// End Game
//add om
const AddOm = lazy(() => import("./modules/CompanyCms/om/HowToJoin/CommonForm"));

// Game
const GameTypeList = lazy(() => import("./modules/GameType"));
const AddGameType = lazy(() => import("./modules/GameType/AddGameType"));
// End Game

// App Flyer Token
const AppFlyerTokenList = lazy(() => import("./modules/AppFlyerTokens/AppFlyerTokenList"));
const AddAppFlyerTokenList = lazy(() => import("./modules/AppFlyerTokens/AddAppFlyerTokenList"));
// App Flyer Token Ends

const HomePage = lazy(() => import("./modules/HomePage/index.js"));
const Dashboardpage = lazy(() => import("./modules/Dashboards/dashboard"));
const DashboardOldpage = lazy(() => import("./modules/Dashboards/dashboard/oldindex"));
const EmailNotification = lazy(() => import("./modules/Reports/EmailNotification"));
const PushNotification = lazy(() => import("./modules/Reports/PushNotification"));
const SmsNotification = lazy(() => import("./modules/Reports/SmsNotification"));
const YoutubeSearchpage = lazy(() => import("./modules/Youtubes/SearchList"));
const YoutubeActivitypage = lazy(() => import("./modules/Youtubes/Activities/list"));
const YoutubeCaptionspage = lazy(() => import("./modules/Youtubes/Captions/list"));
const YoutubeChannelspage = lazy(() => import("./modules/Youtubes/Channels/list"));
const YoutubeChannelSectionpage = lazy(() => import("./modules/Youtubes/ChannelSection/list"));
const YoutubeCommentsListpage = lazy(() => import("./modules/Youtubes/Comments/list"));
const YoutubeCommentsSpampage = lazy(() => import("./modules/Youtubes/Comments/markAsSpam"));
const Youtubei18nLanguagepage = lazy(() => import("./modules/Youtubes/i18nLanguage/list"));
const Youtubei18nRegionspage = lazy(() => import("./modules/Youtubes/i18nRegions/list"));
const YoutubePlaylistItemspage = lazy(() => import("./modules/Youtubes/Playlistitems/list"));
const YoutubePlaylistspage = lazy(() => import("./modules/Youtubes/Playlists/list"));
const YoutubeVideoCategoriespage = lazy(() => import("./modules/Youtubes/VideoCategories/list"));
const Points = lazy(() => import("./modules/Points/index"));
const Sponsors = lazy(() => import("./modules/Sponsors/index"));
const SponsorAds = lazy(() => import("./modules/Sponsors/Ads/index"));
const YoutubeVideospage = lazy(() => import("./modules/Youtubes/Videos/list"));
const CRCardList = lazy(() => import("./modules/ClashRoyale/Cards/index"));
const CRChallengesList = lazy(() => import("./modules/ClashRoyale/Challenges/index"));
const CRCurrentRiverRace = lazy(() => import("./modules/ClashRoyale/Clans/CurrentRiverRace/index"));
const CRCurrentWar = lazy(() => import("./modules/ClashRoyale/Clans/CurrentWar/index"));
const CRClanGetInfo = lazy(() => import("./modules/ClashRoyale/Clans/GetInfo/index"));
const CRClanList = lazy(() => import("./modules/ClashRoyale/Clans/List/index"));
const CRClanListMembers = lazy(() => import("./modules/ClashRoyale/Clans/ListMembers/index"));
const CRRiverRaceLogs = lazy(() => import("./modules/ClashRoyale/Clans/RiverRaceLogs/index"));
const CRGlobalTournamentList = lazy(() => import("./modules/ClashRoyale/GlobalTournament/index"));
const CRLocationClanRanking = lazy(() => import("./modules/ClashRoyale/Locations/ClanRanking/index"));
const CRLocationClanWarRanking = lazy(() => import("./modules/ClashRoyale/Locations/ClanWarRanking/index"));
const CRGetLocation = lazy(() => import("./modules/ClashRoyale/Locations/GetLocation/index"));
const CRGetSeason = lazy(() => import("./modules/ClashRoyale/Locations/GetSeason/index"));
const CRGetTournamentRanking = lazy(() => import("./modules/ClashRoyale/Locations/GetTournamentRanking/index"));
const CRLocationList = lazy(() => import("./modules/ClashRoyale/Locations/List/index"));
const CRPlayerRanking = lazy(() => import("./modules/ClashRoyale/Locations/PlayerRanking/index"));
const CRSeasonList = lazy(() => import("./modules/ClashRoyale/Locations/SeasonList/index"));
const CRSeasonRanking = lazy(() => import("./modules/ClashRoyale/Locations/SeasonRanking/index"));
const CRBattleLog = lazy(() => import("./modules/ClashRoyale/Players/BattleLog/index"));
const CRGetPlayerInfo = lazy(() => import("./modules/ClashRoyale/Players/GetPlayerInfo/index"));
const CRUpcomingChests = lazy(() => import("./modules/ClashRoyale/Players/UpcomingChests/index"));
const CRTournamentInfo = lazy(() => import("./modules/ClashRoyale/Tournaments/GetInfo/index"));
const CRTournamentSearch = lazy(() => import("./modules/ClashRoyale/Tournaments/Search/index"));

const CmsCompanyList = lazy(() => import("./modules/CompanyCms"));
const LeadgerSummaryReportCompanyList = lazy(() => import("./modules/Reports/LeadgerSummaryReport"));
// const LeadgerSummaryReportCompanyList = lazy(() => import("./modules/Reports/LeadgerSummaryReport"));
const Rewards = lazy(() => import("./modules/Rewards/index"));
const DailoyLoginRewards = lazy(() => import("./modules/RewardDailyLoginReward/index"));

const AvatarCategories = lazy(() => import("./modules/AvatarCategories/index"));
const CreateRewards = lazy(() => import("./modules/Reward/CommonForm"));

const Videos = lazy(() => import("./modules/Videos/index"));
const LeaderboardList = lazy(() => import("./modules/CompanyLeaderboard/index"));
const Colleges = lazy(() => import("./modules/Colleges/index"));
const Levels = lazy(() => import("./modules/Levels/index"));
const CompanyLeaderboardList = lazy(() => import("./modules/CompanyLeaderboard/TabCon"));

//GAMERJI CMS
const CMSList1 = lazy(() => import("./modules/CompanyCms/Gamerji"));

// Vi CMS
const CMSList = lazy(() => import("./modules/VICMS"));

// Time Slot
const AddTimeSlot = lazy(() => import("./modules/TimeSlot/TimeSlotForm/index"));
const TimeSlot = lazy(() => import("./modules/TimeSlot/TimeSlotList/index"));
const Avatars = lazy(() => import("./modules/Avatars/index"));
const TransactionsPage = lazy(() => import("./modules/Transactions/index"));
const TransactionsFinshellPage = lazy(() => import("./modules/TransactionsFinshell/index"));
const EasyPaisaTransactionsPage = lazy(() => import("./modules/EasyPaisaTransactions/index"));
const XiaomiTransactionsPage = lazy(() => import("./modules/FunngroTransactions/index"));
const GoPlayTransactionsPage = lazy(() => import("./modules/GoPlayTransactions/index"));
const AmpereTransactionsPage = lazy(() => import("./modules/AmpereTransactions/index"));
const JazzTransactionsPage = lazy(() => import("./modules/JazzTransactions/index"));
const MobilyTransactionsPage = lazy(() => import("./modules/MobilyTransactions/index"));
const GamerjiTransactionsPage = lazy(() => import("./modules/GamerjiTransactions/index.js"));
const GamerjiBanneradslogPage = lazy(() => import("./modules/GamerjiBanneradslogPage/index.js"));
const D11TransactionsPage = lazy(() => import("./modules/D11Transactions/index.js"));
const ViTransactionsPage = lazy(() => import("./modules/ViTransactions/index.js"));
const UserDailyGameReport = lazy(() => import("./modules/Reports/UserDailyGame"));
// Customer Care
const IssueCategoryList = lazy(() => import("./modules/CustomerCare"));

const TicketList = lazy(() => import("./modules/CustomerCare"));

const TournamentTransaction = lazy(() => import("./modules/TournamentTransaction"));

const LeaderBoard = lazy(() => import("./modules/LeaderBoard/ListComponent.js"));
const Banners = lazy(() => import("./modules/Banners/index"));
const Dcontest = lazy(() => import("./modules/Dcontest/index"));
const Acontest = lazy(() => import("./modules/Acontest/index"));
const Bcontest = lazy(() => import("./modules/Bcontest/index"));
const NotificationsPage = lazy(() => import("./modules/Notifications/index"));

// Installable Game
const InstallableGameList = lazy(() => import("./modules/InstallableGame/GameList"));
const AddInstallableGame = lazy(() => import("./modules/InstallableGame/AddGame"));
const InstallableTournaments = lazy(() => import("./modules/InstallableGame/Tournaments"));
const InstallableUserList = lazy(() => import("./modules/InstallableGame/UserList"));

const AddGameCompanyWise = lazy(() => import("./modules/Company/AddGameCompanyWise"));
const Influencers = lazy(() => import("./modules/Influencers/index"));

const UserLoginReport = lazy(() => import("./modules/Reports/UserLoginReport"));
const UserJoinTournamentReport = lazy(() => import("./modules/Reports/UserJoinTournamentReport"));
const VeveAds = lazy(() => import("./modules/VeveAds/index.js"));
// const BuyCoinsReport = lazy(() =>
//   import("./modules/Reports/BuyCoinsReportComponent")
// );

const AddContestV2 = lazy(() => import("./modules/v2/Contests/AddContest"));
const AdReports = lazy(() => import("./modules/AdReport/index.js"));
const EPContestsReport = lazy(() => import("./modules/EPContestReport"));
// const GPContestsReport = lazy(() => import("./modules/GPContestReport"));
// const AMContestsReport = lazy(() => import("./modules/AMContestReport"));

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {helperFunc.isButtonAccess("dashborad.home.list") ? (
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/home" />
        ) : (
          <Redirect exact from="/" to="/home" />
        )}
        <ContentRoute path="/home" component={HomePage} />
        <ContentRoute path="/dashboard" component={Dashboardpage} />
        <ContentRoute path="/dashboardold" component={DashboardOldpage} />

        <ContentRoute path="/analytics" component={Analytics} />
        {/* roles  and permission */}
        <ContentRoute path="/role-and-permissions/module" component={Modulepage} />
        <ContentRoute path="/role-and-permissions/roles" component={Role} />
        {/* roles  and permission */}
        <ContentRoute path="/users/app-users" component={Appuserpage} />
        <ContentRoute path="/users/delete-request" component={DeleteRequest} />
        <ContentRoute path="/users/staff-user" component={StaffUserpage} />
        <ContentRoute path="/affiliateprogram" component={Affiliatepage} />
        <ContentRoute path="/safaricomDashboard" component={Safaricompage} />
        <ContentRoute path="/talabatDashboard" component={Talabatcompage} />
        <ContentRoute path="/bisbDashboard" component={Bisbcompage} />
        <ContentRoute path="/indggDashboard" component={Indggcompage} />
        <ContentRoute path="/ooredooDashboard" component={Ooredoocompage} />
        <ContentRoute path="/gloDashboard" component={Glocompage} />
        <ContentRoute path="/users/staff-user/create" component={StaffUserForm} />
        <ContentRoute path="/affiliateprogram/create" component={AffiliateForm} />

        <ContentRoute path="/users/web-users" component={Webuserpage} />
        <ContentRoute path="/users/all-users" component={Alluserpage} />
        <ContentRoute path="/users/hackerlist" component={HackerList} />
        <ContentRoute path="/muicomponents" component={BasicButtons} />
        {/* Reports */}
        <ContentRoute path="/reports/users" component={UsersReport} />
        <ContentRoute path="/reports/LeadgerSummaryReport" component={LeadgerSummaryReport} />
        <ContentRoute path="/reports/loginlogs" component={LoginLogsReport} />
        <ContentRoute path="/reports/user-game" component={UsersPlayedGamesReport} />
        <ContentRoute path="/reports/user-coin" component={UsersCoinConsumerReport} />
        <ContentRoute path="/reports/MarketingReport" component={MarketingReport} />
        <ContentRoute path="/reports/tournament" component={TournamentReport} />
        <ContentRoute path="/reports/overall-retention" component={RetentionReport} />
        <ContentRoute path="/retention/view/:type/:id" component={RetentionReportView} />
        <ContentRoute path="/reports/buy-coins" component={BuyCoinsReport} />
        <ContentRoute path="/reports/buy-bundles" component={BuyBundlesReport} />
        <ContentRoute path="/reports/cashfree-transactions" component={CashfreeTransactionsReport} />
        <ContentRoute path="/reports/users-ledger" component={UsersLedgerReport} />

        <ContentRoute path="/leaderboard/all" component={AllTimeLeaderBoard} />
        <ContentRoute path="/leaderboard/today" component={TodaysLeaderboard} />
        <ContentRoute path="/leaderboard/monthly" component={MonthlyLeaderBoard} />
        <ContentRoute path="/leaderboard/weekly" component={WeeklysLeaderboard} />

        <ContentRoute
          path="/reports/ledger-summary"
          component={LedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReport"
          component={GamerjiLedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReportt/GJ"
          component={gGamerjiLedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReportt/GJPromotionalReport"
          component={gGamerjiLedgerSummaryReportpromotionalreport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReportt/VI"
          component={gVILedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReportt/D11"
          component={gD11LedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/LeadgerSummaryReportt/ME"
          component={gMELedgerSummaryReport}
        />
        <ContentRoute
          path="/reports/business-daily"
          component={BusinessDailyReport}
        />
        <ContentRoute
          path="/reports/request-call"
          component={RequestLogReport}
        />
        <ContentRoute
          path="/reports/user-login-report"
          component={UserLoginReport}
        />
        <ContentRoute
          path="/reports/user-join-tournament-report"
          component={UserJoinTournamentReport}
        />
        <ContentRoute
          path="/reports/request-create"
          component={CreateRequestLogReport}
        />
        <ContentRoute
          path="/reports/log-calendar"
          component={RequestLogCalendarReport}
        />
        <ContentRoute
          path="/reports/all-time-retention"
          component={AllTimeRetentionReport}
        />
        <ContentRoute path="/reports/ledger-summary" component={LedgerSummaryReport} />
        <ContentRoute path="/reports/business-daily" component={BusinessDailyReport} />
        <ContentRoute path="/reports/request-call" component={RequestLogReport} />
        <ContentRoute path="/reports/user-login-report" component={UserLoginReport} />
        <ContentRoute path="/reports/user-join-tournament-report" component={UserJoinTournamentReport} />
        <ContentRoute path="/reports/app-flyer" component={AppFlyerReport} />
        <ContentRoute path="/reports/add-event" component={AddEvents} />
        <ContentRoute path="/reports/edit-event/:id" component={AddEvents} />

        <ContentRoute path="/reports/app-event" component={AppEventsList} />

        <ContentRoute path="/reports/all-time-retention" component={AllTimeRetentionReport} />
        <ContentRoute path="/reports/contests" component={ContestsReportt} />
        <ContentRoute path="/viDashboard/ContestReport" component={ViContestsReport} />
        <ContentRoute path="/r11Dashboard/ContestReport" component={R11ContestsReport} />
        <ContentRoute path="/reports/user-leaderboard" component={UserLeaderboardReport} />
        <ContentRoute path="/reports/user-game-leaderboard" component={UserGameLeaderboardReport} />
        <ContentRoute path="/reports/retention" component={Retention} />
        <ContentRoute path="/reports/withdrawals-request" component={WithdrawalsRequestReport} />
        <ContentRoute path="/reports/wallet-summary" component={WalletSummaryReport} />
        <ContentRoute path="/reports/gst" component={GstReport} />
        <ContentRoute path="/reports/crm" component={CrmReport} />
        <ContentRoute
          path="/reports/DownloadReport"
          component={DownloadReport}
        />
        <ContentRoute
          path="/reports/logReportDownload"
          component={LogDownloadReport}
        />
        <ContentRoute path="/reports/HostReport" component={HostReport} />
        <ContentRoute path="/reports/UsersPurched" component={UsersPurched} />
        <ContentRoute path="/reports/JoinPaidGame" component={JoinPaidGame} />
        <ContentRoute path="/reports/UsersRedeemrewards" component={UsersRedeemrewards} />
        <ContentRoute path="/video-requests" component={Influencers} />
        <ContentRoute path="/videos" component={Videos} />
        <ContentRoute path="/colleges" component={Colleges} />
        <ContentRoute path="/reports/GamewiseReport" component={GamewiseReport} />

        <ContentRoute path="/reports/CompanyReport" component={CompanyReport} />
        <ContentRoute path="/reports/AdsReport" component={AdsReport} />
        <ContentRoute path="/reports/AdsPosition" component={AdsPosition} />

        {/* Withdrawals Request */}
        <ContentRoute path="/withdrawals-request" component={WithdrawalsRequest} />
        {/* voucher */}
        <ContentRoute path="/voucher/view" component={RewardsBasicProfile} />
        {/* Contests */}
        <ContentRoute path="/contests/list" component={ContestList} />
        <ContentRoute path="/casualcontests/list" component={CasualContestList} />
        <ContentRoute path="/oreedoo-contests/list" component={OreedooContestList} />
        <ContentRoute path="/casualcontests/view/:id" component={CasualContestView} />
        <ContentRoute path="/contests/view/:id" component={ContestView} />
         <ContentRoute path="/ooredoocontests/view/:id" component={OoredooContestView} />
        <ContentRoute path="/partner-contests/view/:id" component={PartnerContestView} />
        <ContentRoute path="/tournaments/contests/view/:id" component={TournamentContestView} />
        <ContentRoute path="/installable-contests/view/:id" component={InstallableContestView} />
        <ContentRoute path="/contests/categories" component={ContestCategories} />
        <ContentRoute path="/contests/add-categories" component={AddContestCategories} />
        <ContentRoute path="/contests/edit-categories/:id" component={AddContestCategories} />
        {/* <ContentRoute path="/contests/user-list" component={ContestUserList} /> */}
        <ContentRoute path="/contests/transactions" component={ContestTransactions} />
        <ContentRoute path="/contests/contests-reports" component={ContestsReport} />
         <ContentRoute path="/contests/gamerji-all-contests-reports" component={NewContestsReport} />
        <ContentRoute path="/tournaments/create" component={TournamentCommonForm} />
        <ContentRoute path="/tournaments/edit/:id" component={TournamentCommonForm} />
        <ContentRoute path="/tournaments/add" component={TournamentSelect} />

        <ContentRoute path="tournaments/gamerjicreate" component={GamerjiTournament} />
        <ContentRoute path="/tournaments/gamerji/edit/:id" component={GamerjiTournament} />
        <ContentRoute path="tournaments/list" component={ListComponent} />
        <ContentRoute path="tournaments/addteam" component={AddTeam} />
        <ContentRoute path="tournaments/contest/:id" component={TournamentContest} />
        <ContentRoute path="tournaments/view/:id" component={TournamentView} />
        <ContentRoute path="tournaments/gamerji/view/:id" component={GamerjiTournamentView} />
        <ContentRoute path="tournaments/gamerji/pointSummary/:id" component={GamerjiTournamentPointSummary} />
        <ContentRoute path="tournaments/gamerji/rankSummary/:id" component={GamerjiTournamentRankSummary} />

        <ContentRoute path="tournaments/teamList/:id" component={TournamentTeams} />
        {/* <ContentRoute path="/countries/list" component={ListComponent} /> */}
        {/* <ContentRoute path="/contest-assign/list" component={ContestAssign} /> */}
        {/* <ContentRoute path="/contests/audit-list" component={AuditContest} /> */}
        {/* <ContentRoute path="/contest-assign-shortlink/list" component={ContestAssignShortLink} /> */}

        {/* //extrahacker */}
        <Route path="/users/hackerlist/extra-hackers" component={ExtraListComponent} />
        {/* <ContentRoute path="/levels" component={Levels} /> */}
        {/* New Contest */}
        <ContentRoute path="/contest-types/list" component={NewContestTypeModule} />
        <ContentRoute path="/contest-types/create" component={AddContestTypeModule} />
        <ContentRoute path="/contest-assign-shortlink/list" component={NewContestShortLink} />
        <ContentRoute path="/contest-assign-shortlink/event-list" component={NewContestEventList} />
        <ContentRoute path="/contest-assign-shortlink/create" component={AddContestShortLink} />
        <ContentRoute path="/contests/user-list" component={NewContestUserList} />
        <ContentRoute path="/contests/user-list/create" component={NewContestUserFrom} />
        <ContentRoute path="/contest-assign/list" component={NewContestAssignList} />
        <ContentRoute path="/contest-assign/create" component={AddContestAssign} />
        <ContentRoute path="/contest-assign/reassign" component={NewContestReAssignList} />
        <ContentRoute path="/contests/audit-list" component={NewAuditContestsList} />
        <ContentRoute path="/contests/create" component={NewAddContest} />
         <ContentRoute path="/casualcontests/create" component={CasualNewAddContest} />
        <ContentRoute path="/contests/edit/:id" component={NewAddContest} />
        <ContentRoute path="/casualcontests/edit/:id" component={CasualNewAddContest} />
        <ContentRoute path="/contests/board" component={NewContestBoard} />
        {/* <ContentRoute path="/contests/view/:id" component={NewContestView} /> */}

        {/* User Profile New */}
        <ContentRoute path="/user-profile/:uid/:companyCode" component={UserProfileMainPage} />
        <ContentRoute path="/user-profile" component={UserProfileMainPage} />
        <ContentRoute path="/points" component={Points} />
        {/* <ContentRoute path="/rewards" component={Rewards} />
         */}

        {/* Roles */}
        <ContentRoute path="/roles" component={NewRole} />
        <ContentRoute path="/countries" component={Countries} />
        <ContentRoute path="/countries-frontend" component={CountriesFrontend} />
        <ContentRoute path="/states" component={States} />
        <ContentRoute path="/cities" component={Cities} />
        {/* Audit */}
        <ContentRoute path="/audit/reasons" component={AuditReasons} />
        <ContentRoute path="/rewards/list" component={Rewards} />
        <ContentRoute path="/dailyLogin-rewards/list" component={DailoyLoginRewards} />
        <ContentRoute path="/dailyLogin-rewards/create" component={DailoyLoginRewards} />
        <ContentRoute path="/dailyLogin-rewards/edit/:id" component={DailoyLoginRewards} />
        <ContentRoute path="/dailyLogin-rewards/view/:id" component={DailoyLoginRewards} />
        {/* <ContentRoute path="/rewards/listt" component={Reward} /> */}
        <ContentRoute path="/reward/list" component={Rewardss} />
        <ContentRoute path="/reward/create" component={Rewardss} />
        <ContentRoute path="/reward/edit/:id" component={Rewardss} />

        {/* <ContentRoute path="/rewards/edit/:id" component={CreateRewards} /> */}
        <ContentRoute path="/rewards/create" component={CreateRewards} />
        {/* Rewards */}
        <ContentRoute path="/rewards/transaction" component={RewardsTransaction} />
        <ContentRoute path="/rewards/categories" component={RewardsCategories} />
        <ContentRoute path="/rewards/products" component={RewardsProductsList} />
        <ContentRoute path="/rewards/live-products" component={RewardsLiveProducts} />

        {/* HTML5Games */}
        <ContentRoute path="/html5-games/html5-categories" component={HTML5GamesCategories} />
        <ContentRoute path="/coupon-categories" component={CouponCategories} />
        <ContentRoute path="/coupons" component={Coupons} />
        <ContentRoute path="/html5-categories" component={H5categories} />
        <ContentRoute path="/H5Games" component={H5Games} />
        <ContentRoute path="/html5-games/games-list" component={HTML5GamesList} />
        <ContentRoute path="/H5Games/joining-list" component={HTML5GamesJoiningList} />
        <ContentRoute path="/H5Games/game-wise-joining-list" component={HTML5GamesWiseJoiningList} />
        <ContentRoute path="/H5Games/setting" component={Setting} />
        {/* scrim */}
        <ContentRoute path="/reports/ScrimsReport" component={ScrimsReport} />
        <ContentRoute path="/reports/ScrimTransactionReport" component={ScrimTransactionReport} />
        <ContentRoute path="/games/scrim-setting/:id" component={AddGameScrimSetting} />
        <ContentRoute path="/scrims/list" component={ScrimsList} />
        {/* <ContentRoute path="/scrims/view/:id" component={ContestView} /> */}
        <ContentRoute path="/scrims/view" component={ScrimView} />
        <ContentRoute path="/DownloadAdscompanylist/list" component={DownloadAdscompanylist} />
        {/* ads company */}
        <ContentRoute path="/DownloadAdscompanylist/list" component={AdscompanyList} />
        <ContentRoute path="/DownloadAdscompanylist/view" component={AdscompanyView} />
        <ContentRoute path="/DownloadAdscompanylist/edit-adds/:id" component={AdscompanyView} />
        <ContentRoute path="/DownloadAdscompanylist/Companydetailpage" component={Companydetailpage} />
        <ContentRoute path="/DownloadAdscompanylist/Adslogs" component={Adslogs} />

        <ContentRoute path="/DownloadAdscompanylist/addcompany" component={Adsaddcompany} />
        <ContentRoute path="/DownloadAdscompanylist/edit-company/:id" component={Adsaddcompany} />

        <ContentRoute path="/subscription/subscriptionlist" component={SubscriptionList} />
        <ContentRoute path="/subscription/subscriptionUserlist" component={SubscriptionUserList} />
        <ContentRoute path="/subscription/addsubscriptionpack" component={Addsubscriptionpack} />
        <ContentRoute path="/subscription/editsubscriptionpack/:id" component={Addsubscriptionpack} />
        <ContentRoute path="/subscription/subscriptionsetting" component={Subscriptionsetting} />

        {/* Game */}
        <ContentRoute path="/games/list" component={GameList} />
        <ContentRoute path="/games/add-game" component={AddGame} />
        <ContentRoute path="/games/casualgame-list" component={CasualGameListGame} />
        <ContentRoute path="/games/casualgame-add" component={CasualGameAddGame} />
        <ContentRoute path="/:companyCode/games/casualgame-edit/:id" component={CasualGameAddGame} />
        <ContentRoute path="/games/casualgame-view/:id" component={CasualGameViewGame} />
        <ContentRoute path="/games/casualgame-assign" component={CasualGameAssignGame} />
        <ContentRoute path="/games/edit-game/:id" component={AddGame} />
        <ContentRoute path="/games/setting/:id" component={AddGameSetting} />

        <ContentRoute path="/casual-game/template-list" component={CasualGameTemplateList} />
        <ContentRoute path="/casual-game/contest-list" component={CasualGameContestList} />
        <ContentRoute path="/casual-game/contest-detail/:id" component={CasualGameContestDetail} />


        {/* external platform */}
        <ContentRoute path="/external-platform/game/list/PBL" component={ExternalPlatformList} />
        <ContentRoute path="/external-platform/game/edit-game/:id" component={AddExternalPlatformList} />

        {/* add om */}
        <ContentRoute path="/cms/company/add-om" component={AddOm} />

        {/* GameType */}
        <ContentRoute path="/game-types/list/:id" component={GameTypeList} />
        <ContentRoute path="/game-types/add-game-type/:game_id" component={AddGameType} />
        <ContentRoute path="/game-types/edit-game-type/:id" component={AddGameType} />

        {/* App Flyer Token */}
        <ContentRoute path="/app-flyer-token/app-flyer-token-list" component={AppFlyerTokenList} />

        <ContentRoute path="/app-flyer-token/add-app-flyer-token" component={AddAppFlyerTokenList} />
        <ContentRoute path="/app-flyer-token/edit-app-flyer-token/:id" component={AddAppFlyerTokenList} />

        <ContentRoute path="/finshellDashboard" component={TransactionsFinshellPage} />
        <ContentRoute path="/easyPaisaDashboard" component={EasyPaisaTransactionsPage} />
        <ContentRoute path="/xiaomiDashboard" component={XiaomiTransactionsPage} />
        <ContentRoute path="/goPlayDashboard" component={GoPlayTransactionsPage} />
        <ContentRoute path="/ampereDashboard" component={AmpereTransactionsPage} />
        <ContentRoute path="/jazzDashboard" component={JazzTransactionsPage} />

        <ContentRoute path="/mobilyDashboard" component={MobilyTransactionsPage} />
        <ContentRoute path="/gamerjiDashboard" component={GamerjiTransactionsPage} />
        <ContentRoute path="/gamerjiDashboard/bannerloglist" component={GamerjiBanneradslogPage} />
        <ContentRoute path="/d11Dashboard" component={D11TransactionsPage} />
        <ContentRoute path="/viDashboard" component={ViTransactionsPage} />
        <ContentRoute path="/transactions" component={TransactionsPage} />
        <ContentRoute path="/notifications" component={NotificationsPage} />

        <ContentRoute path="/company" component={Company} />
        <ContentRoute path="/currencies" component={Currencies} />
        <ContentRoute path="/apkscreen" component={APKScreenList} />
        <ContentRoute path="/levels" component={Levels} />
        <ContentRoute path="/point-categories" component={PointCategories} />

        <ContentRoute path="/company-Addform" component={AddCompanyForm} />
        <ContentRoute path="/company-edit/:id" component={AddCompanyForm} />

        {/* YouTube APIs */}
        <ContentRoute path="/youtube/search/list" component={YoutubeSearchpage} />
        <ContentRoute path="/youtube/activities/list" component={YoutubeActivitypage} />
        <ContentRoute path="/youtube/captions/list" component={YoutubeCaptionspage} />
        <ContentRoute path="/youtube/channels/list" component={YoutubeChannelspage} />
        <ContentRoute path="/youtube/channelSections/list" component={YoutubeChannelSectionpage} />
        <ContentRoute path="/youtube/comments/list" component={YoutubeCommentsListpage} />
        <ContentRoute path="/youtube/comments/markAsSpam" component={YoutubeCommentsSpampage} />
        <ContentRoute path="/youtube/i18nLanguages/list" component={Youtubei18nLanguagepage} />
        <ContentRoute path="/youtube/i18nRegions/list" component={Youtubei18nRegionspage} />
        <ContentRoute path="/youtube/playlistItems/list" component={YoutubePlaylistItemspage} />
        <ContentRoute path="/youtube/playlists/list" component={YoutubePlaylistspage} />
        <ContentRoute path="/youtube/videoCategories/list" component={YoutubeVideoCategoriespage} />
        <ContentRoute path="/youtube/videos/list" component={YoutubeVideospage} />
        <ContentRoute path="/youtube/channel-requests" component={ChannelRequests} />

        <ContentRoute path="/coins/coin-packages" component={CoinPackages} />
        <ContentRoute path="/coins/coin-Addform" component={AddCoinForm} />

        {/* Clash Royale APIs */}
        <ContentRoute path="/cr/cards/list" component={CRCardList} />
        <ContentRoute path="/cr/challenges/list" component={CRChallengesList} />
        <ContentRoute path="/cr/clans/currentriverrace" component={CRCurrentRiverRace} />
        <ContentRoute path="/cr/clans/currentwar" component={CRCurrentWar} />
        <ContentRoute path="/cr/clans/getinfo" component={CRClanGetInfo} />
        <ContentRoute path="/cr/clans/list" component={CRClanList} />
        <ContentRoute path="/sponsors" component={Sponsors} />
        <ContentRoute path="/cr/clans/listmembers" component={CRClanListMembers} />
        <ContentRoute path="/cr/clans/riverracelog" component={CRRiverRaceLogs} />
        <ContentRoute path="/cr/globaltournaments/list" component={CRGlobalTournamentList} />
        <ContentRoute path="/cr/locations/clanranking" component={CRLocationClanRanking} />
        <ContentRoute path="/cr/locations/clanwarranking" component={CRLocationClanWarRanking} />
        <ContentRoute path="/cr/locations/getlocation" component={CRGetLocation} />
        <ContentRoute path="/cr/locations/getseason" component={CRGetSeason} />
        <ContentRoute path="/cr/locations/gettournamentranking" component={CRGetTournamentRanking} />
        <ContentRoute path="/cr/locations/list" component={CRLocationList} />
        <ContentRoute path="/cr/locations/playerranking" component={CRPlayerRanking} />
        <ContentRoute path="/cr/locations/seasonranking" component={CRSeasonRanking} />
        <ContentRoute path="/cr/locations/listseasons" component={CRSeasonList} />
        <ContentRoute path="/cr/players/battlelog" component={CRBattleLog} />
        <ContentRoute path="/cr/players/getinfo" component={CRGetPlayerInfo} />
        <ContentRoute path="/cr/players/upcomingchests" component={CRUpcomingChests} />
        <ContentRoute path="/cr/tournaments/getinfo" component={CRTournamentInfo} />
        <ContentRoute path="/cr/tournaments/list" component={CRTournamentSearch} />
        {/* <ContentRoute path="/retention/not5days" component={RetentionNot5Days} /> */}
        <ContentRoute path="/my-page" component={MyPage} />
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} />
        <ContentRoute path="/blogs" component={Blogs} />
        <ContentRoute path="/NewAside" component={Aside} />
        <ContentRoute path="/leader-board/list" component={LeaderBoard} />
        <ContentRoute path="/sponsor-ads" component={SponsorAds} />
        <ContentRoute path="/banners" component={Banners} />
        <ContentRoute path="/avatar-categories" component={AvatarCategories} />
        <ContentRoute path="/avatars" component={Avatars} />
        <Route path="/reports/notifications/emails" component={EmailNotification} />
        <Route path="/reports/notifications/push" component={PushNotification} />
        <Route path="/users/creatuserid" component={CreateUserId} />
        <Route path="/reports/notifications/sms" component={SmsNotification} />
        <Route path="/staffnewcreate" component={StaffUserFormnew} />
        {/* <Route path="/tournaments/create" component={CommonForm} /> */}
        <Route path="/tournaments/add" component={TournamentSelect} />
        <Route path="/tournaments/gamerjicreate" component={GamerjiTournament} />
        <Route path="/tournaments/gamerji/edit/:id" component={GamerjiTournament} />
        <Route path="/tournaments/list" component={ListComponent} />
        {/* <Route path="/countries/list" component={ListComponent} /> */}
        <Route path="/tournaments/addteam" component={AddTeam} />
        <Route path="/tournaments/view/:id" component={TournamentView} />
        <Route path="/tournaments/gamerji/report" component={TournamentReports} />
        <Route path="/tournaments/gamerji/view/:id" component={GamerjiTournamentView} />
        <Route path="/tournaments/gamerji/pointSummary/:id" component={GamerjiTournamentPointSummary} />
        <Route path="/tournaments/gamerji/rankSummary/:id" component={GamerjiTournamentRankSummary} />
        <Route path="/tournaments/contest-assign/list" component={TournamentContestAssign} />
        <Route path="/tournaments/contest-assign/create" component={NewTournamentContestAssign} />
        <Route path="/tournaments/contest-assign/reassign" component={TournamentContestReAssign} />
        <Route path="/tournaments/contest/:id" component={TournamentContest} />
        <Route path="/tournaments/teamList/:id" component={TournamentTeams} />
        <Route path="/tournaments/rank-summary/:id" component={RankSummary} />
        <Route path="/tournaments/point-summary/:id" component={TournamentPointSummaryView} />
        <ContentRoute path="/LeadgerSummaryReport" component={LeadgerSummaryReportCompanyList} />
        <ContentRoute path="/LeadgerSummaryReport/company" component={LeadgerSummaryReportCompanyList} />
        <ContentRoute path="/cms" component={CmsCompanyList} />
        <ContentRoute path="/cms/company" component={CmsCompanyList} />
        <ContentRoute path="/reports/user-daily-game" component={UserDailyGameReport} />
        {/* <ContentRoute path="/LeadgerSummaryReport/company" component={LeadgerSummaryReportCompanyList} /> */}
        <ContentRoute path="/leaderboard" component={LeaderboardList} />
        <ContentRoute path="/:code/leaderboard" component={CompanyLeaderboardList} />
        <ContentRoute path="/general/" component={GeneralSettings} />
        <ContentRoute path="/allnewreports" component={AllnewReports} />
        <ContentRoute path="/time-slot/list" component={TimeSlot} />
        <ContentRoute path="/time-slot/add" component={AddTimeSlot} />
        <ContentRoute path="/time-slot/edit/:id" component={AddTimeSlot} />
        <ContentRoute path="/issue-categories" component={IssueCategoryList} />
        <ContentRoute path="/ticket" component={TicketList} />
        <ContentRoute path="/editcmsOM/:id" component={EditCmsOM}></ContentRoute>
        <ContentRoute path="/editcmsOM" component={EditCmsOM}></ContentRoute>
        {/* <ContentRoute path="/editcmsom" component={EditCmsOm}></ContentRoute> */}
        <ContentRoute
          path="/editcmsD11/:id"
          component={EditCmsD11}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsOP/:id"
          component={EditCmsOP}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsME/:id"
          component={EditCmsME}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsBS/:id"
          component={EditCmsBS}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsJP/:id"
          component={EditCmsJP}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsGLO/:id"
          component={EditCmsGLO}
        >
        </ContentRoute>
        <ContentRoute
          path="/editcmsTLB/:id"
          component={EditCmsTLB}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsJZ/:id"
          component={EditCmsJZ}
        ></ContentRoute>
         <ContentRoute
          path="/editcmsETL/:id"
          component={EditCmsETL}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsCC/:id"
          component={EditCmsCC}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsEP/:id"
          component={EditCmsEP}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsJZ/:id"
          component={EditCmsJZ}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsETL/:id"
          component={EditCmsETL}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsSCP/:id"
          component={EditCmsSCP}
        ></ContentRoute>
        <ContentRoute
          path="/editcmsVC/:id"
          component={EditCmsVC}
        ></ContentRoute>
        <ContentRoute path="/editcmsD11" component={EditCmsD11}></ContentRoute>
        <ContentRoute path="/editcmsME" component={EditCmsME}></ContentRoute>
        <ContentRoute path="/editcmsBS" component={EditCmsBS}></ContentRoute>
        <ContentRoute path="/editcmsJP" component={EditCmsJP}></ContentRoute>
        <ContentRoute path="/editcmsCC" component={EditCmsCC}></ContentRoute>
        <ContentRoute path="/editcmsGLO" component={EditCmsGLO}></ContentRoute>
        <ContentRoute path="/editcmsTLB" component={EditCmsTLB}></ContentRoute>
        <ContentRoute path="/editcmsJZ" component={EditCmsJZ}></ContentRoute>
        <ContentRoute path="/editcmsETL" component={EditCmsETL}></ContentRoute>
        <ContentRoute path="/editcmsOP" component={EditCmsOP}></ContentRoute>
        <ContentRoute path="/editcmsEP" component={EditCmsEP}></ContentRoute>
        <ContentRoute path="/editcmsSCP" component={EditCmsSCP}></ContentRoute>
        <ContentRoute path="/editcmsVC" component={EditCmsVC}></ContentRoute>
        <ContentRoute
          path="/editcmsGJ/:id"
          component={EditCmsGJ}
        ></ContentRoute>
        <ContentRoute path="/editcmsGJ" component={EditCmsGJ}></ContentRoute>
        <ContentRoute path="/editcmsGP/:id" component={EditCmsGP} ></ContentRoute>
        <ContentRoute path="/editcmsGP" component={EditCmsGP}></ContentRoute>
        <ContentRoute path="/editcmsAM/:id" component={EditCmsAM} ></ContentRoute>
        <ContentRoute path="/editcmsAM" component={EditCmsAM}></ContentRoute>
        <ContentRoute
          path="/editcmsOP/:id"
          component={EditCmsOP}
        ></ContentRoute>
        <ContentRoute path="/editcmsOP" component={EditCmsOP}></ContentRoute>
        <ContentRoute path="/live-streaming" component={LiveStreaming} />
        <ContentRoute path="/dcontest" component={Dcontest} />
        <ContentRoute path="/acontest" component={Acontest} />
        <ContentRoute path="/voucherdetails" component={Bcontest} />
        <ContentRoute
          path="/tournament-transaction"
          component={TournamentTransaction}
        />
        <ContentRoute path="/languages" component={Languages} />
        <ContentRoute
          path="/installable-gameList"
          component={InstallableGameList}
        />
        <ContentRoute
          path="/installable-games/add-game"
          component={AddInstallableGame}
        />
        <ContentRoute
          path="/installable-tournament"
          component={InstallableTournaments}
        />
        <ContentRoute
          path="/installable-userList"
          component={InstallableUserList}
        />
        <ContentRoute path="/coin-stores" component={CoinStores} />

        {/* <Route path="/reports/buy-coins" component={BuyCoinsReport} /> */}

        <ContentRoute path="/company-gameAddform/:id" component={AddGameCompanyWise} />

        <ContentRoute path="/veve-ads" component={VeveAds} />

        <ContentRoute path="/new-contest/create" component={AddContestV2} />
        <ContentRoute path="/new-contest/edit/:id" component={AddContestV2} />
        <ContentRoute path="/AdReport/Report" component={AdReports} />
        <ContentRoute path="/AdReport/AdMobReport" component={AdReports} />
        <ContentRoute path="/easyPaisaDashboard/contestReport" component={EPContestsReport} />
        {/* <ContentRoute path="/goPlayDashboard/contestReport" component={GPContestsReport} /> */}
        {/* <ContentRoute path="/ampereDashboard/contestReport" component={AMContestsReport} /> */}

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
